// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A223","right":"styles_right__10OAH"};